
import stringMixin from './stringMixin';
import { getDateFromTimestamp } from '@/utils';
import moment from 'moment';

export default {
  name: 'XhInput', // 新建 datetime
  components: {},
  mixins: [stringMixin],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    if (this.value && this.value.toString().length == 10) {
      // 编辑的时候 值是时间戳
      this.dataValue = moment(getDateFromTimestamp(this.value)).format('YYYY-MM-DD HH:mm:ss');
    }
  },

  methods: {}
};